<p-toast></p-toast>

<div class="my-hr-page-grid">
  <app-page-form-section
    icon="fa-solid fa-receipt"
    title="Add expense"
    subtitle="Capture a simple employee claim without the finance-heavy expense screen.">
    <div class="form-grid">
      <p-inputgroup>
        <p-inputgroup-addon><i class="pi pi-calendar"></i></p-inputgroup-addon>
        <p-iftalabel>
          <p-datepicker inputId="expenseDate" [(ngModel)]="expenseForm.itemDate" [showIcon]="true" appendTo="body"></p-datepicker>
          <label for="expenseDate">Expense date</label>
        </p-iftalabel>
      </p-inputgroup>

      <p-inputgroup>
        <p-inputgroup-addon><i class="pi pi-wallet"></i></p-inputgroup-addon>
        <p-iftalabel>
          <p-select
            inputId="expenseAccount"
            [options]="workspace?.accounts || []"
            optionLabel="accountName"
            [(ngModel)]="expenseForm.account"
            [filter]="true"
            filterBy="accountName"
            appendTo="body"></p-select>
          <label for="expenseAccount">Expense account</label>
        </p-iftalabel>
      </p-inputgroup>

      <p-inputgroup>
        <p-inputgroup-addon><i class="pi pi-money-bill"></i></p-inputgroup-addon>
        <p-iftalabel>
          <p-inputNumber
            inputId="expenseAmount"
            [(ngModel)]="expenseForm.amount"
            mode="currency"
            [currency]="workspace?.currencyCode || 'SAR'"
            [min]="0"></p-inputNumber>
          <label for="expenseAmount">Amount</label>
        </p-iftalabel>
      </p-inputgroup>

      <p-inputgroup>
        <p-inputgroup-addon><i class="pi pi-percentage"></i></p-inputgroup-addon>
        <p-iftalabel>
          <p-inputNumber
            inputId="expenseTax"
            [(ngModel)]="expenseForm.taxAmount"
            mode="currency"
            [currency]="workspace?.currencyCode || 'SAR'"
            [min]="0"></p-inputNumber>
          <label for="expenseTax">Tax</label>
        </p-iftalabel>
      </p-inputgroup>

      <p-inputgroup class="form-span-2">
        <p-inputgroup-addon><i class="pi pi-file-edit"></i></p-inputgroup-addon>
        <p-iftalabel>
          <textarea id="expenseDescription" pInputTextarea [(ngModel)]="expenseForm.description" rows="3"></textarea>
          <label for="expenseDescription">What is this expense for?</label>
        </p-iftalabel>
      </p-inputgroup>

      <p-inputgroup class="form-span-2">
        <p-inputgroup-addon><i class="pi pi-comment"></i></p-inputgroup-addon>
        <p-iftalabel>
          <textarea id="expenseNotes" pInputTextarea [(ngModel)]="expenseForm.notes" rows="4"></textarea>
          <label for="expenseNotes">Notes or receipt reference</label>
        </p-iftalabel>
      </p-inputgroup>

      <p-inputgroup class="form-span-2 toggle-group">
        <p-inputgroup-addon><i class="pi pi-credit-card"></i></p-inputgroup-addon>
        <label class="checkbox-row">
          <p-checkbox inputId="expenseReimbursable" binary="true" [(ngModel)]="expenseForm.isReimbursable"></p-checkbox>
          <span>Employee reimbursement claim</span>
        </label>
      </p-inputgroup>
    </div>

    <div class="panel-actions-row">
      <button pButton type="button" label="Save draft" icon="pi pi-save" severity="secondary" [loading]="saving" [disabled]="!canCreateExpenses" (click)="save(false)"></button>
      <button pButton type="button" label="Submit for approval" icon="pi pi-send" [loading]="saving" [disabled]="!canCreateExpenses" (click)="save(true)"></button>
    </div>
  </app-page-form-section>

  <app-page-data-panel
    title="My expense claims"
    subtitle="Your recent drafts, submitted expenses, and reimbursement totals."
    [resultText]="(workspace?.expenses?.length || 0) + ' claims'">
    <div class="expense-summary">
      <div>
        <span>Claims</span>
        <strong>{{ workspace?.expenses?.length || 0 }}</strong>
      </div>
      <div>
        <span>Total value</span>
        <strong>{{ monthTotal | currency:(workspace?.currencyCode || 'SAR'):'symbol':'1.0-2' }}</strong>
      </div>
    </div>

    @if (workspace?.expenses?.length) {
      <p-table [value]="workspace?.expenses || []" responsiveLayout="stack" breakpoint="768px">
        <ng-template pTemplate="header">
          <tr>
            <th>Claim</th>
            <th>Date</th>
            <th>Amount</th>
            <th>Status</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-expense>
          <tr>
            <td><span class="p-column-title">Claim</span>{{ expense.description || expense.expenseNumber || ('Expense #' + expense.expenseId) }}</td>
            <td><span class="p-column-title">Date</span>{{ expense.submissionDate | date:'mediumDate' }}</td>
            <td><span class="p-column-title">Amount</span>{{ expense.totalAmount | currency:(expense.currencyCode || 'SAR'):'symbol':'1.0-2' }}</td>
            <td><span class="p-column-title">Status</span><p-tag [value]="label(expense.status)" [severity]="statusSeverity(expense.status)"></p-tag></td>
          </tr>
        </ng-template>
      </p-table>
    } @else {
      <p class="empty-state">No expenses created yet.</p>
    }
  </app-page-data-panel>
</div>
